export default [
  {
    path: 'supplier-due-date',
    name: 'list-debt-supplierduedate',
    component: () =>
      import(
        /* webpackChunkName: "list-debt-supplier-due-date" */ './list/index.vue'
      ),
    meta: {
      title: 'Hạn thanh toán nhà cung cấp - Clickbuy',
    },
  },
];
